import { Type } from "../models/HealthPlan";
import { AuthDetailsAccess, PatientRecordsAccess } from "./Permission";

export enum DocumentReviewActionDispatchTypes {
  DOCUMENT_REVIEW_INVOKE = "DOCUMENT_REVIEW_INVOKE",
  DOCUMENT_REVIEW_SUCCESS = "DOCUMENT_REVIEW_SUCCESS",
  DOCUMENT_REVIEW_RESET = "DOCUMENT_REVIEW_RESET",
}

export enum DocumentDetailActionDispatchTypes {
  POST_PUT_DOCUMENT_DETAIL_ERROR = "POST_PUT_DOCUMENT_DETAIL_ERROR",
  POST_PUT_DOCUMENT_DETAIL_INVOKE = "POST_PUT_DOCUMENT_DETAIL_INVOKE",
  POST_PUT_DOCUMENT_DETAIL_SUCCESS = "POST_PUT_DOCUMENT_DETAIL_SUCCESS",
}

export enum ReferralDocumentFileDispatchTypes {
  PUT_REFERRAL_DOCUMENT_ERROR = "PUT_REFERRAL_DOCUMENT_ERROR",
  PUT_REFERRAL_DOCUMENT_INVOKE = "PUT_REFERRAL_DOCUMENT_INVOKE",
  PUT_REFERRAL_DOCUMENT_SUCCESS = "PUT_REFERRAL_DOCUMENT_SUCCESS",
  PUT_REFERRAL_DOCUMENT_RESET = "PUT_REFERRAL_DOCUMENT_RESET",
}

export enum DocumentDownloadDispatchTypes {
  GET_DOCUMENT_DOWNLOAD_ERROR = "GET_DOCUMENT_DOWNLOAD_ERROR",
  GET_DOCUMENT_DOWNLOAD_INVOKE = "GET_DOCUMENT_DOWNLOAD_INVOKE",
  GET_DOCUMENT_DOWNLOAD_RESET = "GET_DOCUMENT_DOWNLOAD_RESET",
  GET_DOCUMENT_DOWNLOAD_SUCCESS = "GET_DOCUMENT_DOWNLOAD_SUCCESS",
}

export enum ExcelDownloadDispatchTypes {
  EXCEL_DOWNLOAD_ERROR = "EXCEL_DOWNLOAD_ERROR",
  EXCEL_DOWNLOAD_INVOKE = "EXCEL_DOWNLOAD_INVOKE",
  EXCEL_DOWNLOAD_RESET = "EXCEL_DOWNLOAD_RESET",
  EXCEL_DOWNLOAD_SUCCESS = "EXCEL_DOWNLOAD_SUCCESS",
}

const itemHeight = 48;
const itemPaddingTop = 8;
export const menuProps = {
  PaperProps: {
    style: {
      maxHeight: itemHeight * 4.5 + itemPaddingTop,
      width: "15.5rem",
    },
  },
};

export enum DocumentType {
  PDF = "pdf",
  DOC = "msword",
  DOCX = "vnd.openxmlformats-officedocument.wordprocessingml.document",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
  INVALID = "",
}

export enum GenerateAuthTemplateDispatchTypes {
  POST_GENERATE_AUTH_TEMPLATE_ERROR = "POST_GENERATE_AUTH_TEMPLATE_ERROR",
  POST_GENERATE_AUTH_TEMPLATE_INVOKE = "POST_GENERATE_AUTH_TEMPLATE_INVOKE",
  POST_GENERATE_AUTH_TEMPLATE_SUCCESS = "POST_GENERATE_AUTH_TEMPLATE_SUCCESS",
  POST_GENERATE_AUTH_TEMPLATE_RESET = "POST_GENERATE_AUTH_TEMPLATE_RESET",
}

export const Source = {
  FAX: "Fax",
  INBOUND: "Inbound",
  EMAIL: "Email",
};

export enum DocumentTabType {
  DOCUMENT = 1,
  AUTH_DETAILS = 0,
  ATTACH_LETTER = 2,
}

export const documentActions = [
  { label: "ADD NEW DOCUMENT" },
  { label: "GENERAL AUTH TEMPLATE" },
  { label: "SEND FAX" },
  { label: "SEND SECURE NOTIFICATION EMAIL" },
  { label: "ATTACH LETTER" },
];

export const documentDropDownButtons = [
  {
    label: "ADD NEW DOCUMENT",
    permission: `${PatientRecordsAccess.DOCUMENT_CREATE}|${PatientRecordsAccess.DOCUMENT_READ}|`,
    func: "addNewDocument()",
    isDisabled: false,
  },
  {
    label: "GENERATE AUTH TEMPLATE",
    permission: null,
    func: "handleGenerateAuthTemplate()",
    isDisabled: false,
  },
  {
    label: "SEND FAX",
    permission: null,
    func: "openSendFax()",
    isDisabled: false,
  },
  {
    label: "SEND SECURE NOTIFICATION EMAIL",
    permission: null,
    func: "sendSecureNotificationEmail()",
    isDisabled: true,
  },
  {
    label: "ATTACH LETTER",
    permission: `${AuthDetailsAccess.ATTACH_LETTER_CREATE}|${AuthDetailsAccess.ATTACH_LETTER_READ}|`,
    func: "handleAttachLetter()",
    isDisabled: false,
  },
];

export enum DocumentDropDownButtons {
  ADD_NEW_DOCUMENT = "ADD NEW DOCUMENT",
  GENERATE_AUTH_TEMPLATE = "GENERATE AUTH TEMPLATE",
  SEND_FAX = "SEND FAX",
  ATTACH_LETTER = "ATTACH LETTER",
  SEND_SECURE_NOTIFICATION_EMAIL = "SEND SECURE NOTIFICATION EMAIL",
}
export enum AttachLetterActionDispatchTypes {
  POST_ATTACH_LETTER_ERROR = "POST_ATTACH_LETTER_ERROR",
  POST_ATTACH_LETTER_INVOKE = "POST_ATTACH_LETTER_INVOKE",
  POST_ATTACH_LETTER_SUCCESS = "POST_ATTACH_LETTER_SUCCESS",
  POST_ATTACH_LETTER_RESET = "POST_ATTACH_LETTER_RESET",
}

export enum DocumentFieldLabel {
  SERVICE_REQUEST_NUMBER = "Service Request Number:",
  TYPE = "Type:",
  SOURCE = "Source:",
  DOC_TYPE = "Doc Type:",
  MAIL_DATE = "Mail Date:",
  TIME = "Time:",
  DATE_RECEIVED = "Date Received:",
  TIME_RECEIVED = "Time Received:",
  SERVICE_NUMBER = "Service Number(s)"
}

export enum DocumentFieldName {
  DOCUMENT_SOURCE_ID = "documentSourceId",
  DOCUMENT_ID = "documentId",
  SERVICE_REQUEST_NUMBER = "serviceRequestId",
  TYPE = "typeId",
  SERVICE_NUMBER = "serviceRequestDisciplineId",
}

export enum DocumentComponentTitle {
  ADD_DOCUMENTATION = "ADD DOCUMENTATION:",
  ATTACH_LETTER = "ATTACH LETTER:",
  DOCUMENT_ALLOWED_FILE = "Allowed file types (.doc, .docx, .pdf, .jpeg, .jpg, .png, .xlsx, .xls, .txt, .jpe, .jif, .pjp, .pjpeg, .jfif)",
  ATTACH_LETTER_ALLOWED_FILE = "Allowed file types (.pdf)",
}

export enum ServiceRequestDisciplinesActionDispatchTypes {
  GET_SERVICE_REQUEST_DISCIPLINES_INVOKE = "GET_SERVICE_REQUEST_DISCIPLINES_INVOKE",
  GET_SERVICE_REQUEST_DISCIPLINES_SUCCESS = "GET_SERVICE_REQUEST_DISCIPLINES_SUCCESS",
  GET_SERVICE_REQUEST_DISCIPLINES_RESET = "GET_SERVICE_REQUEST_DISCIPLINES_RESET",
  GET_SERVICE_REQUEST_DISCIPLINES_ERROR = "GET_SERVICE_REQUEST_DISCIPLINES_ERROR"
}
export enum ResendFaxFileActionDispatchTypes {
  POST_RESEND_FAX_ERROR = "POST_RESEND_FAX_ERROR",
  POST_RESEND_FAX_INVOKE = "POST_RESEND_FAX_INVOKE",
  POST_RESEND_FAX_SUCCESS = "POST_RESEND_FAX_SUCCESS",
  POST_RESEND_FAX_RESET = "POST_RESEND_FAX_RESET",
}
export enum ResendEmailActionDispatchTypes {
  POST_RESEND_EMAIL_ERROR = "POST_RESEND_EMAIL_ERROR",
  POST_RESEND_EMAIL_INVOKE = "POST_RESEND_EMAIL_INVOKE",
  POST_RESEND_EMAIL_SUCCESS = "POST_RESEND_EMAIL_SUCCESS",
  POST_RESEND_EMAIL_RESET = "POST_RESEND_EMAIL_RESET",
}

export const DOCUMENT_DATE_TYPE_FILTER: Type[] = [
  {
    label: "Equals",
    value: "Equals",
  },
  {
    label: "Not Equals",
    value: "Not Equals",
  },
  {
    label: "Between",
    value: "Between",
  },
  {
    label: "Before",
    value: "Before",
  },
  {
    label: "After",
    value: "After",
  },
];

export enum SendEmailActionDispatchTypes {
  POST_SEND_EMAIL_ERROR = "POST_SEND_EMAIL_ERROR",
  POST_SEND_EMAIL_INVOKE = "POST_SEND_EMAIL_INVOKE",
  POST_SEND_EMAIL_SUCCESS = "POST_SEND_EMAIL_SUCCESS",
  POST_SEND_EMAIL_RESET = "POST_SEND_EMAIL_RESET",
}

export enum EmailDocumentMsg {
  SEPARATE_EMAIL_ADDRESSES = "Separate email addresses with a semicolon.",
  DO_NOT_ADD_SEMICOLON = "Do not add a semicolon after the last email address.",
  MAX_5_EMAILS = "You can enter up to 5 email addresses only.",
  INVALID_EMAIL = "Invalid email: ",
}